import { CheckBoxList, Typography } from "@dealer-center/core-components";

interface BulkImportModalSpeedbumpProps {
  selectedAccount?: string | null;
  currentAccountId?: string | null;
  selectedConfigs: string[];
}

export const BulkImportModalSpeedbump = ({
  selectedAccount,
  currentAccountId,
  selectedConfigs
}: BulkImportModalSpeedbumpProps) => {
  return (
    <>
      <Typography sx={{ mb: 2 }} variant="h2">
        You are importing configs from {selectedAccount} to {currentAccountId}.
      </Typography>
      <CheckBoxList
        options={selectedConfigs.map(config => ({
          label: config,
          value: config,
          disabled: true
        }))}
        values={selectedConfigs}
      />
      <Typography sx={{ mb: 2 }} variant="body-md">
        Please confirm that you want to proceed with the import.
        <br />
        This action cannot be undone.
      </Typography>
    </>
  );
};
